import React from "react";
import { AppBar, Toolbar } from "@mui/material";
import { AtticusLogo } from "@theatticusapp/atticus-shared-components";

interface Props {
  centerLogo?: boolean;
}

const TopBar = ({ centerLogo }: Props): JSX.Element => {
  return (
    <AppBar
      position="fixed"
      sx={{
        backgroundColor: "background.paper",
      }}
      elevation={0}
    >
      <Toolbar
        sx={{
          height: 64,
          justifyContent: centerLogo ? "center" : "flex-start",
        }}
      >
        <AtticusLogo title="Atticus" width="150" />
      </Toolbar>
    </AppBar>
  );
};

export default TopBar;
